import { useMutation } from '@tanstack/react-query'

import { deleteCategoryOfPurchaseApplicationTemplate } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

import { MutationDeleteCategoryOfPurchaseApplicationTemplateArgs } from './type'

export const useDeleteCategoryOfPurchaseApplicationTemplate = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: ({
      organizationId,
      purchaseTemplateCategoryId,
    }: MutationDeleteCategoryOfPurchaseApplicationTemplateArgs) =>
      deleteCategoryOfPurchaseApplicationTemplate(axiosInstance, {
        organizationId,
        purchaseTemplateCategoryId,
      }),
  })
}
